<template>
  <div class="tips">
    <p>
      {{ question.default_value }}
    </p>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "tips",
  mixins: [mixins],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.tips {
  p {
    margin: 5px 0;
    white-space: break-spaces;
  }
}
</style>